module.exports = __webpack_public_path__ + "static/media/round-vpn_key-24px.f6cd5485.svg";